import Map from 'map';
import Clipboard from 'clipboard';

export default class Record {
  setupMap() {
    const map = new Map();
    map.setupMap().then(() => {
      map.build({"records": [$('#js-record-show').data('record')]});
    });
  }
}

$(document).ready(function() {
  if ($('#js-record-show').length) {
    const record = new Record();
    record.setupMap();
    new SimpleBar(document.getElementById('custom-scroll'));
    var clipboard = new Clipboard('.js-shareable-link');
  }
})
